export function isStringLiveValue(tag) {
    return tag?.value_kind === "string";
}

export function formatLiveValue(tag) {
    if (!tag) {
        return "N/A";
    }
    if (isStringLiveValue(tag)) {
        if (tag.last_value === "N/A" || tag.last_value === undefined) {
            return "N/A";
        }
        if (tag.last_value_is_null || tag.last_value === null) {
            return "(null)";
        }
        if (tag.last_value === "") {
            return "(empty)";
        }
        return String(tag.last_value);
    }
    if (typeof tag.last_value === "number") {
        return tag.last_value.toFixed(2);
    }
    if (typeof tag.last_value === "boolean") {
        return tag.last_value ? "true" : "false";
    }
    return tag.last_value;
}

export function numericLiveValue(tag) {
    if (!tag || isStringLiveValue(tag)) {
        return null;
    }
    const value = tag.last_value;
    if (typeof value === "boolean") {
        return value ? 1 : 0;
    }
    if (typeof value === "number" && Number.isFinite(value)) {
        return value;
    }
    if (typeof value === "string" && value.trim() !== "" && value !== "N/A") {
        const number = Number(value);
        if (Number.isFinite(number)) {
            return number;
        }
    }
    return null;
}

export function hasStoredLiveValue(tag) {
    if (!tag) {
        return false;
    }
    if (isStringLiveValue(tag)) {
        if (tag.last_value === "N/A" || tag.last_value === undefined) {
            return false;
        }
        // OPC null and "" are stored readings. They are not missing values.
        return true;
    }
    const value = tag.last_value;
    if (value === "N/A" || value === null || value === undefined) {
        return false;
    }
    if (typeof value === "number") {
        return Number.isFinite(value);
    }
    if (typeof value === "boolean") {
        return true;
    }
    if (typeof value === "string") {
        return true;
    }
    return true;
}
